import { Component, OnInit } from '@angular/core';

import { CoreService } from '@App/Core/core.service';
import { User } from '@Interfaces/User';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
    selector: 'app-welcome-message',
    templateUrl: './welcome-message.component.html'
})
export class WelcomeMessageComponent implements OnInit {

    public welcomeDate: string;
    public user: User;

    constructor(
        private core: CoreService,
        private translate: TranslateService
    ) {
        moment.locale(translate.currentLang || 'fr');
        this.user = core.user;
    }

    ngOnInit() {
        this.welcomeDate = moment(this.core.user.createdAt).startOf('hour').fromNow();
    }

}
